<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['privateLetter'],
      }"
      @click="
        configMainShow['privateLetter'] = !configMainShow['privateLetter']
      "
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>私信作业</span>
        <span
          class="el-switch"
          @click.stop="toggleEnable('privateLetter', '私信作业')"
        >
          <el-switch
            v-model="configure.privateLetter.enable"
            disabled
          ></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['privateLetter'].timeRemaining)
          ? shoWDialogBuy(
              featureList['privateLetter']['productKey'],
              '私信作业',
              'privateLetter'
            )
          : featureList['privateLetter'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.privateLetter.enable
          ? ''
          : toggleEnable('privateLetter', '私信作业')
      "
      :class="{
        'no-buy': isNaN(featureList['privateLetter'].timeRemaining),
        expired: featureList['privateLetter'].timeRemaining <= 0,
        'shut-off': !configure.privateLetter.enable,
      }"
    >
      <el-row>
        <div class="block-tag warning">
          必须是本房间主播或房管才可以写私信作业。本功能是给主播增强留客能力，请勿用作其他扰乱直播生态的用途。（陪玩厅和交友厅除外。）
        </div>
        <el-col :span="5">私信数量</el-col>
        <el-col :span="19">
          <div class="row-padding">
            今日剩余{{ privateCount.today_left }}条，叠加包{{
              privateCount.extend_left
            }}条
            <el-link
              @click="
                shoWDialogBuy(
                  featureList['privateLetter']['productKey'],
                  '私信作业',
                  'privateLetter',
                  'privateLetter'
                )
              "
              type="primary"
              :underline="false"
              >#续费赠送叠加包</el-link
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">频率控制</el-col>
        <el-col :span="19">
          同一事件，一个用户近
          <el-input-number
            v-model="configure.privateLetter.maxDays"
            :controls-position="isPC ? 'right' : ''"
            size="mini"
            :min="1"
            :max="90"
          ></el-input-number
          >天最多发
          <el-input-number
            v-model="configure.privateLetter.dayMaxCount"
            :controls-position="isPC ? 'right' : ''"
            size="mini"
            :min="0"
          ></el-input-number
          >次
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">总量控制</el-col>
        <el-col :span="19">
          每天总量限制
          <el-input-number
            v-model="configure.privateLetter.dayMaxCountTotal"
            :controls-position="isPC ? 'right' : ''"
            size="mini"
            :min="0"
          ></el-input-number
          >条，
          <el-switch
            v-model="configure.privateLetter.dayMaxCountWXPushEnable"
          ></el-switch
          >超出总量发微信通知
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5"
          >私信对象
          <span id="privateLetterBigData" class="hide-anchor-point"></span
        ></el-col>
        <el-col :span="19">
          <!-- <div class="block-tag warning"
            v-if="
              isNaN(featureList['bigData'].timeRemaining) ||
                featureList['bigData'].timeRemaining <= 0
            ">
            近期消费能力需要「大数据」功能支持。
            <el-link
              class="block-tag-link"
              type="primary"
              :underline="false"
              @click="
                shoWDialogBuy(
                  featureList['bigData']['productKey'],
                  '大数据',
                  'bigData'
                )
              "
              >立即开通</el-link
            >
          </div> -->
          <!-- row-padding -->
          <div>
            <!-- <div
              class="big-data-modules"
              @click="
                isNaN(featureList['bigData'].timeRemaining)
                  ? shoWDialogBuy(
                      featureList['bigData']['productKey'],
                      '大数据',
                      'bigData'
                    )
                  : featureList['bigData'].timeRemaining <= 0
                  ? showFunctionalRenewal(true)
                  : configure.bigData.enable
                  ? ''
                  : toggleEnable('bigData', '大数据')
              "
              :class="{
                'no-buy': isNaN(featureList['bigData'].timeRemaining),
                expired: featureList['bigData'].timeRemaining <= 0,
                'shut-off': !configure.bigData.enable,
              }"
            >
              <el-checkbox
                v-model="configure.privateLetter.entryVIP.consumeEnable"
                >近期消费≥
                <el-select
                  @click.stop
                  v-model="configure.privateLetter.entryVIP.consumeLevel"
                  size="mini"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in consumeLevelConfig"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option> </el-select
                >，进场后发私信</el-checkbox
              >
            </div> -->
            <div>
              <el-checkbox
                v-model="configure.privateLetter.entryVIP.nobleLevelEnable"
                >贵族等级≥
                <el-select
                  @click.stop
                  v-model="configure.privateLetter.entryVIP.nobleLevel"
                  size="mini"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in welcomeConfig"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option> </el-select
                >，进场后发私信</el-checkbox
              >
            </div>
            <!-- <div>
              <el-checkbox
                v-model="configure.privateLetter.entryVIP.interactEnable"
                >对麦上用户发私信</el-checkbox
              >
            </div> -->
          </div>
          <div class="row-padding">
            第一条私信：
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.entryVIP.tpl[0]"
                    @input="checkEmpty(configure.privateLetter.entryVIP.tpl, 0)"
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <div class="row-padding">
            <el-switch
              v-model="configure.privateLetter.entryVIPNoReply1.enable"
            ></el-switch
            >如果大哥不回，
            <el-select
              v-model="configure.privateLetter.entryVIPNoReply1.time"
              slot="prepend"
              placeholder="选择直播间"
              size="mini"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in timeList"
                :key="item.value"
              ></el-option> </el-select
            >后，发第二条私信：
          </div>
          <div v-show="configure.privateLetter.entryVIPNoReply1.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.entryVIPNoReply1.tpl[0]"
                    @input="
                      checkEmpty(
                        configure.privateLetter.entryVIPNoReply1.tpl,
                        0
                      )
                    "
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="row-padding">
            <el-switch
              v-model="configure.privateLetter.entryVIPNoReply2.enable"
            ></el-switch
            >如果大哥不回，
            <el-select
              v-model="configure.privateLetter.entryVIPNoReply2.time"
              slot="prepend"
              placeholder="选择直播间"
              size="mini"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in timeList"
                :key="item.value"
              ></el-option> </el-select
            >后，发第三条私信：
          </div>
          <div v-show="configure.privateLetter.entryVIPNoReply2.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.entryVIPNoReply2.tpl[0]"
                    @input="
                      checkEmpty(
                        configure.privateLetter.entryVIPNoReply2.tpl,
                        0
                      )
                    "
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div> -->
          <div class="row-padding">
            <el-switch
              v-model="configure.privateLetter.entryVIPReply.enable"
            ></el-switch
            >如果大哥回了，则发私信：
          </div>
          <div v-show="configure.privateLetter.entryVIPReply.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.entryVIPReply.tpl[0]"
                    @input="
                      checkEmpty(configure.privateLetter.entryVIPReply.tpl, 0)
                    "
                    :labels="['userNick', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="false">
        <el-col :span="5">陪玩下单</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.privateLetter.accompanyOrder.enable"
            ></el-switch
            >下单金额≥
            <el-input-number
              v-model="configure.privateLetter.accompanyOrder.amount"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :precision="1"
              size="mini"
            ></el-input-number
            >元，下单后发私信
          </div>
          <div v-show="configure.privateLetter.accompanyOrder.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.accompanyOrder.tpl[0]"
                    @input="
                      checkEmpty(configure.privateLetter.accompanyOrder.tpl, 0)
                    "
                    :labels="['userNick', 'accompanySkill', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">送礼金额</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.privateLetter.giftAmount.enable"
            ></el-switch
            >一次性金额≥
            <el-input-number
              v-model="configure.privateLetter.giftAmount.amount"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              :precision="1"
              size="mini"
            ></el-input-number
            >元，送礼后发私信
          </div>
          <div v-show="configure.privateLetter.giftAmount.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.giftAmount.tpl[0]"
                    @input="
                      checkEmpty(configure.privateLetter.giftAmount.tpl, 0)
                    "
                    :labels="['userNick', 'gift', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">粉丝牌升级</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.privateLetter.fansLevelUpgrade.enable"
            ></el-switch
            >粉丝牌等级≥
            <el-input-number
              v-model="configure.privateLetter.fansLevelUpgrade.level"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >，升级后发私信
          </div>
          <div v-show="configure.privateLetter.fansLevelUpgrade.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.fansLevelUpgrade.tpl[0]"
                    @input="
                      checkEmpty(
                        configure.privateLetter.fansLevelUpgrade.tpl,
                        0
                      )
                    "
                    :labels="['userNick', 'badge', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">开通贵族</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.privateLetter.nobleOpen.enable"
            ></el-switch
            >贵族等级≥
            <el-select
              v-model="configure.privateLetter.nobleOpen.level"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in welcomeConfig"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> </el-select
            >，开通后发私信
          </div>
          <div v-show="configure.privateLetter.nobleOpen.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.nobleOpen.tpl[0]"
                    @input="
                      checkEmpty(configure.privateLetter.nobleOpen.tpl, 0)
                    "
                    :labels="['userNick', 'noble', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">续费贵族</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.privateLetter.nobleContinue.enable"
            ></el-switch
            >贵族等级≥
            <el-select
              v-model="configure.privateLetter.nobleContinue.level"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in welcomeConfig"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> </el-select
            >，续费后发私信
          </div>
          <div v-show="configure.privateLetter.nobleContinue.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.nobleContinue.tpl[0]"
                    @input="
                      checkEmpty(configure.privateLetter.nobleContinue.tpl, 0)
                    "
                    :labels="['userNick', 'noble', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">开通守护</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.privateLetter.guardOpen.enable"
            ></el-switch
            >守护等级≥
            <el-input-number
              v-model="configure.privateLetter.guardOpen.level"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >，开通后发私信
          </div>
          <div v-show="configure.privateLetter.guardOpen.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.guardOpen.tpl[0]"
                    @input="
                      checkEmpty(configure.privateLetter.guardOpen.tpl, 0)
                    "
                    :labels="['userNick', 'guardLevel', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">续费守护</el-col>
        <el-col :span="19">
          <div>
            <el-switch
              v-model="configure.privateLetter.guardContinue.enable"
            ></el-switch
            >守护等级≥
            <el-input-number
              v-model="configure.privateLetter.guardContinue.level"
              :controls-position="isPC ? 'right' : ''"
              :min="0"
              size="mini"
            ></el-input-number
            >，续费后发私信
          </div>
          <div v-show="configure.privateLetter.guardContinue.enable">
            <div class="sentence">
              <ul>
                <li>
                  <Editor
                    v-model="configure.privateLetter.guardContinue.tpl[0]"
                    @input="
                      checkEmpty(configure.privateLetter.guardContinue.tpl, 0)
                    "
                    :labels="['userNick', 'guardLevel', 'anchorNick']"
                  ></Editor>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('私信作业', 'privateLetter')"
          >「私信」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
import { getPrivateCount } from "@/api/index";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      //贵族配置项
      welcomeConfig: require("@/assets/js/welcomeConfig.json"),
      consumeLevelConfig: require("@/assets/js/consumeLevelConfig.json"),
      timeList: [
        {
          value: "5",
          label: "5分钟",
        },
        {
          value: "15",
          label: "15分钟",
        },
        {
          value: "30",
          label: "30分钟",
        },
        {
          value: "1440",
          label: "1天",
        },
        {
          value: "4320",
          label: "3天",
        },
        {
          value: "10080",
          label: "7天",
        },
      ],
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    privateCount: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    ticket: {
      type: String,
      default: "",
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  mounted() {},
  methods: {
    getPrivateCount() {
      getPrivateCount({
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          this.privateCount = res.data;
        }
      });
    },
    warningClose() {
      this.$message({
        message: "至少需要配置一种私信对象，如不想写私信可以关闭私信功能的开关",
        type: "error",
      });
    },
  },
};
</script>
